import { render } from "./OccupiersWorkstationComponent.vue?vue&type=template&id=26487040&scoped=true&ts=true"
import script from "./OccupiersWorkstationComponent.vue?vue&type=script&lang=ts"
export * from "./OccupiersWorkstationComponent.vue?vue&type=script&lang=ts"

import "./OccupiersWorkstationComponent.vue?vue&type=style&index=0&id=26487040&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26487040"]])

export default __exports__